import React, { useState } from "react";
import { Checkbox, Col, ConfigProvider, Divider, Form, Modal, Row, Switch, Table, Tag } from "antd";
import Input from "../../../../components/Input/Input";
import Select from "../../../../components/Select/Select";
import Text from "../../../../components/Text/Text";
import "./../../CODiscountClass.css";
import Button from "../../../../components/Button/Button";
import { FlexCol } from "../../../../components/Container/Container";
import { ModalSelectStore } from "../../../Shared/ModalSelectStore";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import color from "../../../../resource/color";
import { numberFormatter } from "../../../../utility/Formatter";
import { onInputNumberKeyPress } from "../../../../utility/validator";
import { checkCoDuplicate, onCheckDuplicate } from "../CreateCODiscountList";
import { FixedType } from "rc-table/lib/interface";
import { mapStatus } from "../IndexCODiscountList";
import { DetailDuplicateModal } from "../../CODiscountComponent";

export const CODiscountStepTwoShop: React.FC<{
  form1: any;
  form2: any;
  zoneList: any[];
  cusGroupList: any[];
  errorMessage?: any;
  setErrorMessage?: any;
}> = ({ form1, form2, zoneList, cusGroupList, errorMessage, setErrorMessage }) => {
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const [selectShopModal, setSelectShopModal] = useState(false);
  const [sameConditionModal, setSameConditionModal] = useState(false);
  const [modalDuplicate, setModalDuplicate] = useState<any>({ data: undefined, open: false });
  const [modalDeleteShop, setModalDeleteShop] = useState<boolean>(false);
  const _watchShops = Form.useWatch("shops", form2);
  const _watchCoId = Form.useWatch("coId", form1);

  const [searchZone, setSearchZone] = useState<any>(undefined);
  const [searchGroup, setSearchGroup] = useState<any>(undefined);
  const [searchText, setSearchText] = useState<any>(undefined);

  const onSetStore = (data: any) => {
    const mapShop = form2.getFieldValue("shops")
      ? [
          ...form2.getFieldValue("shops"),
          ...data.map((item: any) => ({
            ...item,
            checked: false,
            quotaAmount: undefined,
            percentAmount: undefined,
            status: true,
          })),
        ]
      : data.map((item: any) => ({
          ...item,
          checked: false,
          quotaAmount: undefined,
          percentAmount: undefined,
          status: true,
        }));
    form2.setFieldsValue({
      ...form2.getFieldsValue(true),
      shops: mapShop,
      searchShop: mapShop,
    });
  };

  const onSearchShop = (zone?: string, group?: string, text?: string) => {
    const mapShop = form2.getFieldValue("shops");
    const filterShop = mapShop.filter((shop: any) => {
      shop;
      const zoneMatch = zone ? shop.zone === zone : true;
      const groupMatch = group ? shop.customerGroupName === group : true;
      const textMatch = text
        ? shop.customerName.includes(text) || shop.customerNo.includes(text)
        : true;
      return zoneMatch && groupMatch && textMatch;
    });
    form2.setFieldsValue({
      ...form2.getFieldsValue(true),
      searchShop: filterShop,
    });
  };

  const onDeleteShop = () => {
    const mapShop = form2.getFieldValue("shops");
    const filterShop = mapShop.filter((shop: any) => !shop.checked);
    form2.setFieldsValue({
      ...form2.getFieldsValue(true),
      shops: filterShop,
      searchShop: filterShop,
    });
  };

  const columes = [
    {
      title: (
        <Checkbox
          checked={_watchShops?.every((shop: any) => {
            return shop?.isSwitchDisabled && shop?.quotaUsed > 0 ? true : shop.checked;
          })}
          onChange={(e) => {
            const checked = e.target.checked;
            const mapShop = form2.getFieldValue("shops");
            const mapSearchShop = form2.getFieldValue("searchShop");
            const mapShopList = mapShop.map((shop: any) => {
              if (shop?.isSwitchDisabled && shop?.quotaUsed > 0) {
                return { ...shop, checked: false };
              }
              return { ...shop, checked };
            });
            const mapSearchShopList = mapSearchShop.map((shop: any) => {
              if (shop?.isSwitchDisabled && shop?.quotaUsed > 0) {
                return { ...shop, checked: false };
              }
              return { ...shop, checked };
            });
            form2.setFieldsValue({
              ...form2.getFieldsValue(true),
              shops: mapShopList,
              searchShop: mapSearchShopList,
            });
          }}
        />
      ),
      dataIndex: "checked",
      key: "checked",
      width: "3%",
      render: (value: any, record: any) => {
        return (
          <>
            <Checkbox
              checked={value}
              disabled={record?.isSwitchDisabled && record?.quotaUsed > 0 ? true : false}
              onChange={(e) => {
                const checked = e.target.checked;
                const mapShop = form2.getFieldValue("shops");
                const mapSearchShop = form2.getFieldValue("searchShop");
                const mapShopList = mapShop.map((shop: any) =>
                  shop.customerCompanyId === record.customerCompanyId ? { ...shop, checked } : shop,
                );
                const mapSearchShopList = mapSearchShop.map((shop: any) =>
                  shop.customerCompanyId === record.customerCompanyId ? { ...shop, checked } : shop,
                );
                form2.setFieldsValue({
                  ...form2.getFieldsValue(true),
                  shops: mapShopList,
                  searchShop: mapSearchShopList,
                });
              }}
            />
          </>
        );
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "30%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Form.Item name={["shops", index, "customerCompanyId"]} noStyle>
                <Text>{value}</Text>
                <Text color='Text3'>
                  {row.customerNo} • เขต {row.zone} • กลุ่ม {row.customerGroupName || "-"}
                </Text>
              </Form.Item>
              {row.isDuplicate && (
                <Row>
                  <Text level={6} color={row?.isSwitchDisabled ? "error" : "warning"}>
                    {row?.isSwitchDisabled
                      ? "ร้านค้ากำลังใช้งานส่วนลดอื่นอยู่"
                      : "ร้านนี้มีสินค้าที่ซ้ำกับส่วนลดอื่น"}
                  </Text>
                  &nbsp;&nbsp;
                  <Text
                    level={6}
                    color={row?.isSwitchDisabled ? "error" : "warning"}
                    style={{ cursor: "pointer" }}
                    onClick={() => setModalDuplicate({ data: row.coDuplicateList, open: true })}
                  >
                    <u>ดูเพิ่มเติม</u>
                  </Text>
                </Row>
              )}
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ส่วนลดรวม",
      dataIndex: "quotaAmount",
      key: "quotaAmount",
      width: "12%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Form.Item
                name={["shops", index, "quotaAmount"]}
                rules={[{ required: true, message: "กรุณากรอกส่วนลดรวม" }]}
              >
                <Input
                  style={{ color: color.BK }}
                  autoComplete='off'
                  suffix='฿'
                  placeholder='0'
                  onKeyDown={onInputNumberKeyPress}
                  disabled={form1.getFieldValue("coId") && row?.coShopId ? true : false}
                />
              </Form.Item>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "% ของยอดบิล",
      dataIndex: "percentAmount",
      key: "percentAmount",
      width: "12%",
      hidden: form1.getFieldValue("type") === "BILL_PCT" ? false : true,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Form.Item
                name={["shops", index, "discountPct"]}
                rules={[
                  { required: true, message: "กรุณากรอก % ของยอดบิล" },
                  {
                    validator: (_, value) => {
                      if (Number(value) > 100) {
                        return Promise.reject(new Error("ส่วนลดต้องไม่เกิน 100%"));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  autoComplete='off'
                  suffix='%'
                  placeholder='0'
                  onKeyDown={onInputNumberKeyPress}
                  style={{ color: color.BK }}
                  disabled={form1.getFieldValue("coId") && row?.isSwitchDisabled ? true : false}
                />
              </Form.Item>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ใช้ไป",
      dataIndex: "quotaUsed",
      key: "quotaUsed",
      width: "10%",
      hidden: form1.getFieldValue("coId") ? false : true,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text color={value > 0 ? "error" : "BK"}>
                {value > 0 ? `-${numberFormatter(value)}` : numberFormatter(value || 0)} ฿
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "คงเหลือ",
      dataIndex: "quotaUsed",
      key: "quotaUsed",
      width: "10%",
      hidden: form1.getFieldValue("coId") ? false : true,
      render: (value: any, row: any, index: number) => {
        const cal = row.quotaAmount - row.quotaUsed;
        return {
          children: (
            <FlexCol style={{ alignItems: "flex-end" }}>
              <Text color={cal > 0 ? "success" : "Text1"}>{numberFormatter(cal || 0)} ฿</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "หมายเหตุถึง Sale",
      dataIndex: "latestSaleRemarkText",
      key: "latestSaleRemarkText",
      width: "12%",
      hidden: form1.getFieldValue("coId") ? false : true,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value || "-"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "หมายเหตุถึง Dealer",
      dataIndex: "latestDealerRemarkText",
      key: "latestDealerRemarkText",
      width: "12%",
      hidden: form1.getFieldValue("coId") ? false : true,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value || "-"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      width: "8%",
      fixed: "right" as FixedType | undefined,
      render: (value: any, row: any, index: number) => {
        const mapTextStatus = value ? "ACTIVE" : "INACTIVE";
        return {
          children: (
            <FlexCol>
              {row.coShopId ? (
                <Tag
                  style={{
                    backgroundColor: mapStatus(mapTextStatus)?.bgColor,
                    border: "none",
                  }}
                >
                  <Text
                    style={{ color: mapStatus(mapTextStatus)?.textColor }}
                    fontWeight={600}
                    level={6}
                  >
                    {mapStatus(mapTextStatus)?.text}
                  </Text>
                </Tag>
              ) : (
                <Form.Item name={["shops", index, "status"]} noStyle>
                  <Switch disabled={row.isSwitchDisabled} />
                </Form.Item>
              )}
            </FlexCol>
          ),
        };
      },
    },
  ].filter((item) => !item.hidden);

  return (
    <>
      <Form form={form2} layout='vertical'>
        <div style={{ paddingBottom: "10px" }}>
          <span
            className='card-label font-weight-bolder text-dark'
            style={{ fontSize: 20, fontWeight: "bold" }}
          >
            เลือกร้านค้า และระบุส่วนลดดูแลราคา
          </span>
          <Text level={6} color='error' fontWeight={600}>
            {errorMessage?.step === 2 && errorMessage?.message}
          </Text>
        </div>
        <Row justify={"space-between"} gutter={8}>
          {form2.getFieldValue("shops")?.length > 0 ? (
            <>
              <Col span={8}>
                <Input
                  value={searchText}
                  placeholder='ค้นหาชื่อร้านค้า'
                  suffix={<SearchOutlined />}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    onSearchShop(searchZone, searchGroup, e.target.value);
                  }}
                />
              </Col>
              <Col span={3}>
                <Select
                  value={searchZone}
                  data={
                    zoneList?.map((zone) => ({
                      label: zone.zoneName,
                      value: zone.zoneName,
                      key: zone.zoneName,
                    })) || []
                  }
                  placeholder='เลือกเขต'
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    setSearchZone(e);
                    onSearchShop(e, searchGroup, searchText);
                  }}
                />
              </Col>
              <Col span={4}>
                <Select
                  value={searchGroup}
                  data={cusGroupList || []}
                  placeholder='กลุ่มร้านค้า'
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    setSearchGroup(e);
                    onSearchShop(searchZone, e, searchText);
                  }}
                />
              </Col>
              <Col span={3}>
                <Button
                  typeButton='primary-light'
                  title='ล้างการค้นหา'
                  onClick={() => {
                    setSearchZone(undefined);
                    setSearchGroup(undefined);
                    setSearchText(undefined);
                    onSearchShop(undefined, undefined, undefined);
                  }}
                />
              </Col>
              <Col span={2} />
              <Col style={{ paddingTop: "10px" }}>
                {form2?.getFieldValue("shops")?.some((shop: any) => shop.checked) && (
                  <DeleteOutlined
                    onClick={() => setModalDeleteShop(true)}
                    style={{ fontSize: "20px", color: color.error, cursor: "pointer" }}
                  />
                )}
                {modalDeleteShop && (
                  <Modal
                    open={modalDeleteShop}
                    centered
                    closable={true}
                    maskClosable={false}
                    okText='บันทึก'
                    cancelText='ยกเลิก'
                    title={
                      <Text fontWeight={600} level={2}>
                        ลบร้านค้าที่เลือก
                      </Text>
                    }
                    onOk={() => {
                      onDeleteShop();
                      setModalDeleteShop(false);
                    }}
                    onCancel={() => setModalDeleteShop(false)}
                    cancelButtonProps={{
                      style: { borderColor: color.primary, color: color.primary },
                    }}
                  >
                    <Text color='Text3'>โปรดยืนยันการลบร้านค้า</Text>
                    <Divider size='small' />
                  </Modal>
                )}
              </Col>
            </>
          ) : (
            <Col span={21} />
          )}
          <Col span={3}>
            <Button
              typeButton='primary'
              title='เพิ่มร้านค้า'
              onClick={() => setSelectShopModal(true)}
            />
          </Col>
        </Row>
        {form2?.getFieldValue("shops")?.length > 0 && (
          <>
            <br />
            <Row justify={"space-between"} gutter={8}>
              <Col span={4}>
                {form2?.getFieldValue("shops")?.some((shop: any) => shop.checked) && (
                  <Button
                    typeButton='primary-light'
                    title='ตั้งค่าเงื่อนไขเดียวกัน'
                    onClick={() => {
                      setSameConditionModal(true);
                    }}
                  />
                )}
              </Col>
              <Col style={{ paddingTop: "15px" }}>
                <Text color='Text3'>
                  จำนวนที่เลือก {form2.getFieldValue("shops")?.length || 0} ร้านค้า •
                  ส่วนลดรวมทั้งหมด
                </Text>
                &nbsp;&nbsp;
                <Text color='primary'>
                  {numberFormatter(
                    form2
                      .getFieldValue("shops")
                      ?.reduce(
                        (acc: number, shop: any) => acc + (Number(shop.quotaAmount) || 0),
                        0,
                      ),
                  )}{" "}
                  ฿
                </Text>
              </Col>
            </Row>
          </>
        )}
        <br />
        <ConfigProvider
          theme={{
            components: {
              Table: {
                headerBg: "#1B4586",
                headerColor: "#FFFFFF",
                fontFamily: "IBM Plex Sans Thai",
                fontSize: 15,
                //rowHoverBg: "none",
              },
            },
          }}
        >
          <Form.Item name='shops' noStyle>
            <Table
              columns={columes}
              dataSource={form2.getFieldValue("searchShop") || []}
              rowKey='customerCompanyId'
              tableLayout='fixed'
              scroll={{
                x: form1.getFieldValue("coId") ? 1500 : undefined,
                y: 600,
              }}
              pagination={false}
            />
          </Form.Item>
        </ConfigProvider>
      </Form>
      {selectShopModal && (
        <ModalSelectStore
          callBackShop={async (data) => {
            onSetStore(data);
            setErrorMessage({ step: undefined, message: "" });
            const form2Shops = form2.getFieldValue("shops") || [];
            const form2Products = form2.getFieldValue("products") || [];
            const selectedShopIds = form2Shops.map((item: any) => Number(item.customerCompanyId));
            const selectProductIds = form2Products.map((item: any) => String(item.productId)) || [];

            const checkDup = await checkCoDuplicate(
              userCompany?.companyCode,
              form1.getFieldValue("type"),
              form1.getFieldValue("startDate"),
              form1.getFieldValue("endDate"),
              selectedShopIds,
              selectProductIds,
              form1.getFieldValue("coId") || undefined,
            );

            onCheckDuplicate(checkDup, form2);
            setSelectShopModal(false);
          }}
          showModalShop={selectShopModal}
          currentSelectShop={form2.getFieldValue("shops") || []}
          company={userCompany.companyCode}
          onClose={() => setSelectShopModal(false)}
        />
      )}
      {sameConditionModal && (
        <Modal
          centered
          closable={true}
          maskClosable={false}
          open={sameConditionModal}
          okText='บันทึก'
          cancelText='ยกเลิก'
          onOk={() => {
            const dataForm2 = form2.getFieldsValue(true);
            const newShops = dataForm2.shops.map((item: any) => {
              if (item.checked === false || item.coShopId) return { ...item, checked: false };
              return {
                ...item,
                quotaAmount: dataForm2.sameDiscount || item.quotaAmount,
                discountPct: dataForm2.samePercent || item.percentAmount,
                checked: false,
              };
            });
            form2.setFieldsValue({
              shops: newShops,
              searchShop: newShops,
              sameDiscount: undefined,
              samePercent: undefined,
            });
            setSameConditionModal(false);
          }}
          onCancel={() => setSameConditionModal(false)}
          title={
            <Text fontWeight={600} level={4}>
              ตั้งค่าพร้อมกันทุกร้าน
            </Text>
          }
        >
          <Form form={form2} layout='vertical'>
            <Form.Item label='ส่วนลดรวม' name={"sameDiscount"}>
              <Input
                autoComplete='off'
                suffix='฿'
                placeholder='0'
                onKeyDown={onInputNumberKeyPress}
              />
            </Form.Item>
            {form1.getFieldValue("type") === "BILL_PCT" && (
              <Form.Item label='% ของยอดบิล' name={"samePercent"}>
                <Input
                  autoComplete='off'
                  suffix='%'
                  placeholder='0'
                  onKeyDown={onInputNumberKeyPress}
                />
              </Form.Item>
            )}
          </Form>
        </Modal>
      )}
      {modalDuplicate.open && (
        <DetailDuplicateModal
          dataDup={modalDuplicate.data}
          open={modalDuplicate.open}
          setOpen={(open: boolean) => setModalDuplicate({ ...modalDuplicate, open })}
        />
      )}
    </>
  );
};
